var versions = {
    "0.1.0": require("./0.1.0/reference.json"),
    "0.2.0": require("./0.2.0/reference.json"),
    "0.3.0": require("./0.3.0/reference.json"),
    "0.4.0": require("./0.4.0/reference.json"),
    "0.6.0": require("./0.6.0/reference.json"),
    "0.7.0": require("./0.7.0/reference.json"),
    "0.9.0": require("./0.9.0/reference.json"),
    "0.10.0": require("./0.10.0/reference.json"),
    "0.14.0": require("./0.14.0/reference.json"),
    "0.15.0": require("./0.15.0/reference.json"),
    "0.16.0": require("./0.16.0/reference.json"),
    "0.17.0": require("./0.17.0/reference.json"),
    "0.18.0": require("./0.18.0/reference.json"),
    "0.19.0": require("./0.19.0/reference.json"),
    "0.20.0": require("./0.20.0/reference.json"),
    "0.21.0": require("./0.21.0/reference.json"),
    "0.22.0": require("./0.22.0/reference.json"),
    "0.23.0": require("./0.23.0/reference.json"),
    "0.26.0": require("./0.26.0/reference.json"),
    "0.27.0": require("./0.27.0/reference.json"),
    "0.29.0": require("./0.29.0/reference.json"),
    "0.33.0": require("./0.33.0/reference.json"),
    "0.34.0": require("./0.34.0/reference.json"),
    "0.37.0": require("./0.37.0/reference.json"),
    "0.37.1": require("./0.37.1/reference.json"),
    "0.38.0": require("./0.38.0/reference.json"),
    "0.40.0": require("./0.40.0/reference.json"),
    "0.41.0": require("./0.41.0/reference.json"),
    "0.43.0": require("./0.43.0/reference.json"),
    "0.44.0": require("./0.44.0/reference.json"),
    "0.47.0": require("./0.47.0/reference.json"),
    "0.51.0": require("./0.51.0/reference.json"),
    "0.52.0": require("./0.52.0/reference.json"),
    "0.54.0": require("./0.54.0/reference.json"),
    "0.55.0": require("./0.55.0/reference.json"),
    "0.55.1": require("./0.55.1/reference.json"),
    "0.58.1": require("./0.58.1/reference.json"),
    "0.59.3": require("./0.59.3/reference.json"),
    "0.59.4": require("./0.59.4/reference.json")
};

versions.latest = versions["0.59.4"];
module.exports = versions;



//////////////////
// WEBPACK FOOTER
// ./~/camshaft-reference/versions/index.js
// module id = 1483
// module chunks = 6